/* eslint-disable max-len */
/* eslint no-nested-ternary: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push, replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import Auth from '@aws-amplify/auth';
import qs from 'qs';
import _ from 'lodash';
import {
  Container,
  Dimmer,
  Dropdown,
  Grid,
  Icon,
  Loader,
  Menu,
  Segment,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import config from '../../../config';
// actions
import { fetchM } from '../../actions/fetchM';
import { fetchBobForms } from '../../actions/bobForms';
import { fetchTemplates } from '../../actions/templates';
import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { fetchAddressSettings } from '../../actions/addressSettings';
// utils
import isNumber from '../../utils/numbers/isNumber';
import { isVietnamCompany } from '../../utils/vietnam';
import { decodeSearch, encodeSearch } from '../../utils/url';
// components
import BookingActivities from '../../components/BookingActivities';
import BookingSectionTab from '../../components/Bookings/BookingSectionTab';
import BookingTitle from '../../components/Bookings/BookingTitle';
import NavBar from '../../components/NavBar';
import PageNav from '../../components/PageNav';
import SearchFilter from '../../components/SearchFilter';
import SortButton from '../../components/SortButton';
// structs
import BOOKING_DEFAULT from '../../structs/booking';
import { CANCELLED_BOOKING_STATUSES } from '../../constants/bookingStatuses';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import FormSharingModal from '../modals/FormSharingModal';

const isPRS = config.get('prs');

class Activities extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        settings: PropTypes.shape({
          bookingHideLoanTracker: PropTypes.bool,
        }),
      }),
    }),
    routeParamsID: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    bobForms: PropTypes.shape({
      data: PropTypes.array,
    }),
    templates: PropTypes.shape({
      data: PropTypes.shape({
        print: PropTypes.array,
      }),
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
    templates: state.templates,
    bobForms: state.bobForms,
  })
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const windowWidth = window.innerWidth;
    const activitiesData = [];
    const data = Object.assign({}, BOOKING_DEFAULT, props.data);
    const isMobile = windowWidth < 768;
    const loading = props.loading;
    const search = query.search || '';
    const hideLoanTracker = props.appConfig && props.appConfig.data && props.appConfig.data.settings && props.appConfig.data.settings.bookingHideLoanTracker;
    const tabID = 6;
    const showShareEmailModal = false;
    const isMalaysia = props.auth && props.auth.company && props.auth.company.countryCode.toUpperCase() === 'MY';
    // CPI-976: Vietnam's E-Sign is hidden on the Purchaser tab; the description should not mention it.
    const sectionTabs = [
      { id: 1, title: 'Info', description: 'Status, Pricing & Payment' },
      { id: 2, title: 'Purchaser', description: isVietnamCompany(props.auth) ? 'Details & Eligibility' : 'Details, E-Sign & Eligibility' },
      { id: 3, title: 'Tracker', description: 'Loan & SPA/LA Tracker', disabled: hideLoanTracker },
    ];
    sectionTabs.push(
      ...(!isMalaysia
        ? [{
          id: 4,
          title: 'Payment Plan',
          description: 'Pending Selection',
          disabled: data.project && !data.project.paymentPlanFlow,
        }]
        : []),
      { id: 5, title: 'Documents', description: 'Document Sharing' },
      { id: 6, title: 'Logs', description: 'Activity Logs', page: 'activities/' },
    );
    // CPI-974 (AC16): Vietnam has no MHub Buyer App, and the buyerProfileID arm means the
    // project flag alone would still show the tab on a booking that was linked earlier.
    if (!isVietnamCompany(props.auth) &&
      (data.buyerProfileID || (data.project.linkBuyerApp && !CANCELLED_BOOKING_STATUSES.some(s => data.statusID === s.value)))) {
      sectionTabs.push({ id: 7, title: 'Buyer App', description: 'Status & Progress' });
    }
    return {
      activitiesData,
      data,
      isMobile,
      loading,
      query,
      search,
      tabID,
      sectionTabs,
      showShareEmailModal,
    };
  }
  constructor(props) {
    super(props);
    const state = Activities.getPropsToState(props);
    state.limit = 0;
    state.offset = 0;
    state.currentPage = parseInt(state.query.page, 10) || 1;
    state.count = 0;
    state.printTemplates = [];
    this.state = {
      ...state,
      docxPrintTemplates: [],
    };
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchTemplates('print', true));
    store.dispatch(fetchBobForms(true));
    store.dispatch(fetchAddressSettings());
  }
  componentDidMount() {
    const { query } = this.props.location;
    this.getBookingActivities(query);
    if (this.state.data && this.state.data.id) {
      this.fetchPrintTypes();
      this.getBookingPaymentPlan(this.state.data.id);
      this.fetchDocxTemplates(this.state.data);
    }
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const { query } = nextProps.location;
    const { activitiesData, data, bookingPaymentPlan, sectionTabs } = this.state;
    const state = Activities.getPropsToState(nextProps);
    const isDataSame = JSON.stringify(data) === JSON.stringify(state.data);

    if (isDataSame) {
      state.bookingPaymentPlan = bookingPaymentPlan;
      state.sectionTabs = sectionTabs;
    }

    if (activitiesData) {
      state.activitiesData = activitiesData;
    }
    this.setState({ ...state }, () => {
      if (!activitiesData) {
        this.getBookingActivities(query);
      }
      if (!isDataSame && state.data.id) {
        this.fetchPrintTypes();
        this.getBookingPaymentPlan(state.data.id);
        this.fetchDocxTemplates(state.data);
      }
    });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getBookingPaymentPlan = async (bookingID) => {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${bookingID}/payment_plan/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const bookingPaymentPlan = await res.json();
      // mutate payment plan tab's description
      const sectionTabs = _.map(this.state.sectionTabs, (st) => {
        const nst = { ...st };
        if (st.id === 4) nst.description = this.generatePaymentPlanTabDescription(bookingPaymentPlan);
        return nst;
      });
      this.setState({ bookingPaymentPlan, sectionTabs });
    }
    await this.setLoading(false);
  };
  async getBookingActivities(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let queryString = '';
    let res = null;
    if (qs.stringify(query)) {
      queryString = `?${qs.stringify(query)}`;
    }
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.props.routeParamsID}/activities/${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    } else {
      const activitiesData = await res.json();
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      await this.setComponentState({
        count,
        limit,
        offset,
        activitiesData,
      });
      await this.setLoading(false);
    }
  }
  checkICIsImage = (customer) => {
    let isImage = customer.icFrontDocumentID !== '' || customer.icBackDocumentID !== '';
    if (customer.icFrontDocumentID !== '' && customer.icFrontDocument && customer.icFrontDocument.name) {
      // NOTE: this checking will not work if filename don't hav extension
      if (customer.icFrontDocument.name.toLowerCase().includes('.pdf')) isImage = false;
    }
    if (customer.icBackDocumentID !== '' && customer.icBackDocument && customer.icBackDocument.name) {
      // NOTE: this checking will not work if filename don't hav extension
      if (customer.icBackDocument.name.toLowerCase().includes('.pdf')) isImage = false;
    }
    return isImage;
  }
  checkIfBookingStatusAllowedToViewForm = (formAccessibility, booking) => {
    if (booking.statusID === 'expired') {
      return true;
    }
    switch (booking.statusID) {
      case 'reserved':
        return formAccessibility && formAccessibility.isEnabledOnReserved;
      case 'booked':
        return formAccessibility && formAccessibility.isEnabledOnBooked;
      case 'cancelled_developer':
      case 'cancelled_availability':
        return formAccessibility && formAccessibility.isEnabledOnCancelled;
      case 'sold_spa_signed':
        return formAccessibility && formAccessibility.isEnabledOnSold;
      default:
        return false;
    }
  }
  checkIfCompanyBranchAllowedToViewForm = (formAccessibility) => {
    const { auth } = this.props;
    // empty company branch IDs means accessible to all
    if (formAccessibility && (!formAccessibility.companyBranchIDs || formAccessibility.companyBranchIDs.length === 0)) {
      return true;
    }
    if (formAccessibility && formAccessibility.companyBranchIDs && auth.companyBranch && auth.companyBranch.id && formAccessibility.companyBranchIDs.includes(auth.companyBranch.id)) {
      return true;
    }
    return false;
  }
  checkIfFormAccessibleToViewForm = (currentPFA, booking) => {
    const { data } = this.state;
    const formAccessibilities = data && data.project && data.project.projectFormAccessibilities ? data.project.projectFormAccessibilities : [];
    const pfaIdx = formAccessibilities.findIndex(fa => fa.templateID === currentPFA.templateID);
    if (pfaIdx !== -1) {
      const selectedPfa = formAccessibilities[pfaIdx];
      const isCompanyBranchAllowedToView = this.checkIfCompanyBranchAllowedToViewForm(selectedPfa);
      const isBookingStatusAllowedToView = this.checkIfBookingStatusAllowedToViewForm(selectedPfa, booking);
      return isCompanyBranchAllowedToView && isBookingStatusAllowedToView;
    }
    return false;
  }
  generatePaymentPlanTabDescription = (bookingPaymentPlan) => {
    if (bookingPaymentPlan && !_.isEmpty(bookingPaymentPlan.id)) {
      const isEdited = _.some(bookingPaymentPlan.bookingPaymentPlanDetails, bppd => bppd.customized);
      return `${bookingPaymentPlan.code}${isEdited ? ' (edited)' : ''}`;
    }
    return 'Pending Selection';
  };
  setLoading = (loading = false, loadingType) => new Promise((res) => {
    if (loadingType === 'validatingTIN') {
      this.setState({ validatingTin: loading }, res);
    } else {
      this.setState({ loading }, res);
    }
  })
  fetchPrintTypes = () => {
    const { templates, bobForms, t } = this.props;
    const { data } = this.state;
    const output = [];
    if (data
      && data.project
      && data.project.projectFormAccessibilities
      && templates
      && templates.data
      && templates.data.print
    ) {
      data.project.projectFormAccessibilities.forEach((pfa) => {
        const isAllowedToView = this.checkIfFormAccessibleToViewForm(pfa, data);
        if (isAllowedToView) {
          const selectedTemplate = templates.data.print.find(t => t.id === pfa.templateID);
          if (selectedTemplate && selectedTemplate.name && selectedTemplate.id) {
            output.push({ value: selectedTemplate.id, text: selectedTemplate.name });
          }
        }
      });
    }
    if (data
      && data.project
      && data.project.bobFormIDs
      && bobForms
      && bobForms.data
    ) {
      data.project.bobFormIDs.forEach((f) => {
        bobForms.data.forEach((t) => {
          if (f === t.id) {
            output.push({
              value: f,
              text: t.title,
              type: 'BOB',
            });
          }
        });
      });
    }

    // add IC options if customer has IC images uploaded
    if (data && data.bookingCustomers && data.bookingCustomers.length > 0) {
      if (data.bookingCustomers.some(bc => this.checkICIsImage(bc.customer))) {
        output.push({
          value: 'customer_identities',
          text: t('Purchasers’ IC'),
        });
      }
    }

    this.setState({ printTemplates: output });
  }
  async fetchDocxTemplates(data) {
    const { store } = this.context;
    const { t, auth } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/docxtemplates/projects/${data.project.id}/templates/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      this.setState({ docxPrintTemplates: [] });
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
      this.setState({ docxPrintTemplates: [] });
    } else {
      const docxPrintTemplates = await res.json();
      let tempTemplates = [];
      if (docxPrintTemplates && docxPrintTemplates.length > 0) {
        const statusFieldMap = {
          reserved: 'isEnabledOnReserved',
          booked: 'isEnabledOnBooked',
          cancelled_developer: 'isEnabledOnCancelled',
          cancelled_availability: 'isEnabledOnCancelled',
          sold: 'isEnabledOnSold',
          sold_spa_signed: 'isEnabledOnSold',
        };
        const field = statusFieldMap[data.statusID];
        tempTemplates = docxPrintTemplates
          .filter(template => template.isEnabled && field && template[field] && Array.isArray(template.visibleToBusinessUnits) && template.visibleToBusinessUnits.includes(auth.companyBranch.id))
          .map(template => ({
            value: template.id,
            text: template.name.replace('.docx', ''),
            type: 'docx',
          }));
      }
      // always set state so templates from a previous booking are cleared when the
      // current project has none (MS-6015), without resetting on unrelated props changes (MS-6448)
      this.setState({ docxPrintTemplates: tempTemplates });
    }
  }
  getPrintLink = (data, form) => {
    if (form.value === 'customer_identities') {
      return `${config.get('bookApiURL')}/bookings/${data ? data.id : ''}/identities/`;
    }
    return `${config.get('bookApiURL')}/bookings/${data ? data.id : ''}/template/${btoa(form.value)}/print/`;
  }
  async replaceQuery(query, resetPage = false) {
    await this.setLoading(true);
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) queryNew.page = 1;
    await this.getBookingActivities(query);
    store.dispatch(replace(`/bookings/${this.props.routeParamsID}/activities/?${encodeSearch(queryNew)}`));
    await this.setLoading(false);
  }
  checkAllowPrint = (data) => {
    const { isBranchLeader, isHeadquarters } = this.props.auth;
    const isCancelledStatus = data.statusID === 'cancelled_developer' || data.statusID === 'cancelled_availability';

    if ((data.project.projectFormAccessibilities && data.project.projectFormAccessibilities.length > 0 && data.statusID) || (this.state.docxPrintTemplates && this.state.docxPrintTemplates.length && data.statusID)) {
      if (data.project.hidePrintAgentStaff) {
        // If HidePrintAgentStaff is ticked && booking is under Reserved OR Cancelled status && isBranchLeader or HQ then allow print
        if ((data.statusID === 'reserved' || isCancelledStatus) && (isBranchLeader || isHeadquarters)) {
          return true;
        }
        // If HidePrintAgentStaff is ticked && booking is under Booked or Sold status then allow print for all
        if (data.statusID === 'booked' || data.statusID === 'sold_spa_signed') {
          return true;
        }
      } else {
        // If HidePrintAgent is not ticked and not PRS server, then allow print
        if (!isPRS) return true;
        // If HidePrint is not ticked, is PRS server && statusID is booked OR sold, then allow print
        if (
          (data.project.projectFormAccessibilities && data.project.projectFormAccessibilities.length > 0 &&
            (
              (data.statusID && data.statusID === 'booked') ||
              (data.statusID && data.statusID === 'sold_spa_signed') ||
              isCancelledStatus ||
              this.hasAccess()
            )
          ) ||
          (this.state.docxPrintTemplates && this.state.docxPrintTemplates.length > 0 &&
            (
              (data.statusID && data.statusID === 'booked') ||
              (data.statusID && data.statusID === 'sold_spa_signed') ||
              isCancelledStatus ||
              this.hasAccess()
            )
          )
        ) {
          return true;
        }
      }
    }
    return false;
  }
  handlePrintForm = async (e, form, isPDF, type = '') => {
    const { data } = this.state;
    if (form && form.value) {
      const query = isPDF ? '?pdf=true' : '';
      if (type === 'BOB') {
        const bobQuery = isPDF ? `?formID=${form.value}&pdf=true` : `?formID=${form.value}`;
        window.open(`${config.get('bookApiURL')}/bookings/${data ? data.id : ''}/bob/${bobQuery}`, '_blank');
        return;
      }
      // URL to print all purchasers' IC
      if (form.value === 'customer_identities') {
        window.open(`${config.get('bookApiURL')}/bookings/${data ? data.id : ''}/identities/${query}`, '_blank');
        return;
      }
      if (type === 'docx') {
        this.setState({ isPrinting: true });
        try {
          await this.handlePrintDocxTemplate(form.value);
        } catch (error) {
          console.error('An error occurred during DOCX generation.', error);
        } finally {
          this.setState({ isPrinting: false });
        }
        return;
      }
      window.open(`${config.get('bookApiURL')}/bookings/${data ? data.id : ''}/template/${btoa(form.value)}/print/${query}`, '_blank');
    }
  }
  handlePrintDocxTemplate = async (form) => {
    const { data } = this.state;
    const { store } = this.context;
    // await this.setState({ loading: true });
    let res;
    try {
      res = await store.dispatch(fetchM(`/docxtemplates/templates/${form}/print/?bookingID=${data.id}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      // await this.setState({ loading: false });

      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        // return;
        throw err;
      }

      store.dispatch(flashErrorMessage(err));
      // return;
      throw err;
    }
    // Convert the response to a Blob
    const blob = await res.blob();

    // Create a temporary URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Open the PDF in a new tab for preview
    window.open(url, '_blank');

    // Create a temporary link element to trigger the download
    const downloadLink = document.createElement('a');
    downloadLink.href = url;

    // Set the filename for the downloaded file
    // Manually format the date components in local time
    const now = moment().toDate();
    const formattedDate = now.getFullYear() +
      String(now.getMonth() + 1).padStart(2, '0') +
      String(now.getDate()).padStart(2, '0') +
      String(now.getHours()).padStart(2, '0') +
      String(now.getMinutes()).padStart(2, '0') +
      String(now.getSeconds()).padStart(2, '0');
    const filename = `Booking-${data.code}-${formattedDate}.pdf`;
    downloadLink.download = filename;

    // Trigger the download in the background
    document.body.appendChild(downloadLink);
    downloadLink.click();

    // Clean up by removing the temporary link and revoking the object URL
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(url);
    // await this.setState({ loading: false });
  }
  handlePrint = () => {
    Auth.currentSession();
  }
  handleResize = () => {
    const state = {};
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      state.isMobile = isMobile;
      this.setState({ ...state });
    }
  }
  handleTabChange = (tabData) => {
    if (!tabData) return;
    const tabID = tabData.id;
    const { store } = this.context;
    const query = decodeSearch(this.props.location.search);
    let tab = 'info';
    switch (tabID) {
      case 1:
        tab = 'info';
        break;
      case 2:
        tab = 'purchaser';
        break;
      case 3:
        tab = 'tracker';
        break;
      case 4:
        tab = 'payment_plan';
        break;
      case 5:
        tab = 'documents';
        break;
      case 6:
        tab = 'logs';
        break;
      case 7:
        tab = 'buyer';
        break;
      default:
        tab = 'info';
        break;
    }
    query.section = tab;
    delete query.page;
    this.setState({ tabID }, () => {
      if (tab === 'logs') {
        this.getBookingActivities(query);
      } else if (tabData.page) {
        delete query.section;
        store.dispatch(push(`/bookings/${this.state.data.id}/${tabData.page}?${encodeSearch(query)}`));
      } else {
        store.dispatch(replace(`/bookings/${this.state.data.id}/?${encodeSearch(query)}`));
      }
    });
  }
  hasAccess(check = false) {
    if (this.props.auth.isHeadquarters) {
      return true;
    }
    if (this.props.auth.isSuperAdmin) {
      return true;
    }
    return check;
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      this.replaceQuery(query, true);
    } else {
      this.setState({ search: '' });
    }
  }
  handleOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  handleOnOpenShareEmail = (e) => {
    e.preventDefault();
    this.setState({ showShareEmailModal: true });
  }
  handleOnCloseShareEmail = (e) => {
    e.preventDefault();
    this.setState({ showShareEmailModal: false });
  }
  handleProceedShareEmail = (e, data) => {
    e.preventDefault();
    this.sendEmail(data);
  }
  async sendEmail(body) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t, token } = this.props;
    const { data } = this.state;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${data.id}/customers/${data.bookingCustomer.customerID}/send_email/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
        },
        body: JSON.stringify(body),
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await store.dispatch(flashSuccessMessage({
        header: t('Share Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Successfully generate and send email to primary purchaser', { ns: TRANSLATION_FILES.translation }),
      }));
    }
    await this.setLoading(false);
  }
  sortItems = [
    {
      text: 'Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'booking_activity.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'booking_activity.created_at',
      sortDirection: 'desc',
    },
  ];
  render() {
    const {
      activitiesData,
      data,
      loading,
      isMobile,
      tabID,
      sectionTabs,
      printTemplates,
      docxPrintTemplates,
      isPrinting,
    } = this.state;
    const { t } = this.props;
    const printTmplOnly = printTemplates ? printTemplates.filter(({ value }) => value !== 'customer_identities') : [];
    const combinedPrintTemplates = [...docxPrintTemplates, ...printTemplates];

    return (
      <Container>
        <NavBar
          header={t('Booking Overview')}
          rightNav={
            this.checkAllowPrint(data && data) ? (
              <Menu.Item fitted>
                <div className="printButton">
                  {/* For PDF */}
                  {data.project.printPDF && printTmplOnly.length === 1 ? (
                    <Link
                      as="a"
                      className="ui medium compact primary button icon"
                      disabled={loading}
                      onClick={this.handlePrint}
                      target="_blank"
                      to={`${config.get('bookApiURL')}/bookings/${
                        data ? data.id : ''
                      }/template/${btoa(
                        printTemplates[0].value,
                      )}/print/?pdf=true`}
                    >
                      <Icon name="file outline pdf" fitted={isMobile} />
                      <small>{isMobile ? '' : ' PDF'}</small>
                    </Link>
                  ) : (
                    data.project.printPDF &&
                    printTmplOnly.length > 1 && (
                      <Dropdown
                        pointing="top right"
                        button
                        compact
                        labeled={!isMobile}
                        icon="file outline pdf"
                        text={isMobile ? '' : 'PDF'}
                        className="ui medium compact primary button icon print_dropdown"
                        style={{
                          marginRight: '10px',
                          height: '30px',
                          verticalAlign: 'middle',
                        }}
                      >
                        <Dropdown.Menu>
                          {/* NOTE: print purchasers' IC don't support print PDF now */}
                          {printTmplOnly.map(({ text, value, type }) => (
                            <Dropdown.Item
                              key={`${value}_${text}`}
                              name="printType"
                              value={value}
                              onClick={(e, form) =>
                                this.handlePrintForm(e, form, true, type)
                              }
                            >
                              {text}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    )
                  )}
                  {/* For HTML/DOCX Print */}
                  {
                    // if no templates & IC
                    combinedPrintTemplates.length === 1 ? (
                      (() => {
                        const template = combinedPrintTemplates[0];
                        const isDocx = template.type === 'docx';
                        const showLoading = isDocx && isPrinting;
                        return (
                          <Link
                            as="a"
                            className={`ui medium compact primary button icon ${
                              showLoading ? 'disabled' : ''
                            }`}
                            disabled={showLoading}
                            onClick={(e) => {
                              e.preventDefault();
                              if (showLoading) return; // Prevent clicking while loading
                              this.handlePrintForm(
                                e,
                                { value: template.value },
                                false,
                                template.type,
                              );
                            }}
                            target="_blank"
                            to={
                              !isDocx ? this.getPrintLink(data, template) : '#'
                            }
                          >
                            {showLoading ? (
                              <Icon name="spinner" loading fitted={isMobile} />
                            ) : (
                              <Icon name="print" fitted={isMobile} />
                            )}
                            <small>
                              {isMobile
                                ? ''
                                : ` ${
                                    showLoading ? t('Printing...') : t('Print')
                                  }`}
                            </small>
                          </Link>
                        );
                      })()
                    ) : (
                      <Dropdown
                        pointing="top right"
                        button
                        labeled={!isMobile}
                        icon="print"
                        text={isMobile ? '' : t('Print')}
                        className="ui medium compact primary button icon print_dropdown"
                        loading={isPrinting}
                        disabled={isPrinting}
                        style={{
                          marginRight: '10px',
                          height: '30px',
                          verticalAlign: 'middle',
                        }}
                      >
                        <Dropdown.Menu>
                          {combinedPrintTemplates.map(
                            ({ text, value, type }) => (
                              <Dropdown.Item
                                key={`${value}_${text}`}
                                name="printType"
                                value={value}
                                onClick={(e, form) =>
                                  this.handlePrintForm(e, form, false, type)
                                }
                              >
                                {text}
                              </Dropdown.Item>
                            ),
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    )
                  }
                  <FormSharingModal
                    open={this.state.showShareEmailModal}
                    onClose={this.handleOnCloseShareEmail}
                    onProceed={this.handleProceedShareEmail}
                    printTemplates={printTmplOnly}
                  />
                </div>
              </Menu.Item>
            ) : null
          }
          bottomNode={
            <BookingSectionTab
              loading={this.state.loading}
              isMobile={isMobile}
              isSticky
              onTabChange={this.handleTabChange}
              tabs={sectionTabs}
              tabID={tabID}
            />
          }
        />
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">
              {t('Loading', { ns: TRANSLATION_FILES.translation })}
            </Loader>
          </Dimmer>
          <Grid.Row style={{ paddingBottom: '0' }}>
            <Grid.Column>
              <BookingSectionTab
                loading={loading}
                isMobile={isMobile}
                onTabChange={this.handleTabChange}
                tabs={sectionTabs}
                tabID={tabID}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <BookingTitle isMobile={isMobile} data={data} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <SearchFilter
                isLoading={this.state.loading}
                onChange={this.handleOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                placeholder={t('Search')}
                setAdvanceFilter={() => {}}
                leftNav={
                  <PageNav
                    currentPage={this.state.currentPage}
                    count={this.state.count}
                    limit={this.state.limit}
                    offset={this.state.offset}
                    dataSize={this.state.activitiesData.length}
                    loading={this.state.loading}
                    onChange={this.handleChangePage}
                  />
                }
                rightNav={
                  <SortButton
                    floated="right"
                    loading={this.state.loading}
                    items={this.sortItems.map(item => ({
                      ...item,
                      text: t(item.text, { ns: TRANSLATION_FILES.translation }),
                    }))}
                    onSort={this.handleSortData}
                  />
                }
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16} textAlign="center">
              <Segment>
                <BookingActivities
                  data={activitiesData || []}
                  hasAccess={this.hasAccess()}
                  loading={this.state.loading}
                />
              </Segment>
              <PageNav
                currentPage={this.state.currentPage}
                count={this.state.count}
                limit={this.state.limit}
                offset={this.state.offset}
                dataSize={this.state.activitiesData.length}
                loading={this.state.loading}
                onChange={this.handleChangePage}
                upward
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}
export default withTranslation(namespaces)(connect(Activities.mapStateToProps)(Activities));



// WEBPACK FOOTER //
// ./src/containers/Bookings/Activities.jsx